import { Button } from '@mantine/core';
import { useLocation, useNavigate, useParams } from 'react-router';
import { ErrorBoundary } from '@morph-mapper/ui';
import { useStore } from '@/store';
import { t } from 'i18next';

export const GraphErrorBoundary = () => {
  const [init, getRef] = useStore(({ graphs: g }) => [g.init, g.getRef]);
  const { graphId, templateId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isResetDisabled = graphId === undefined;

  const handleResetGraph = () => {
    if (graphId === undefined) return;

    // TODO: Check if resetting works in the case of a nested graph.
    init({ id: graphId, ref: getRef(graphId) });
    navigate(location.pathname, { replace: true });
  };

  const handleOverview = () => {
    navigate(`/${templateId}/entries`);
  };

  return (
    <ErrorBoundary
      message={t('graphEditor.errorBoundary.message')}
      buttons={[
        <Button
          color="blue"
          variant="filled"
          onClick={handleResetGraph}
          disabled={isResetDisabled}
        >
          {t('graphEditor.errorBoundary.resetGraph')}
        </Button>,
        <Button color="gray" variant="outline" onClick={handleOverview}>
          {t('graphEditor.errorBoundary.goToOverview')}
        </Button>,
      ]}
    />
  );
};
